export { default } from "./FilterContent";
